<template>
    <span v-if="mostrarIcone">
        <span class="text-primary ml-1">
            <i
                class="fa fa-pie-chart fa-lg icon-button"
                title="Atualizar Centro de Custo"
                @click.stop="mostrarModal = true"
            ></i>
        </span>
        <dotacao-form
            :mostrarModal="mostrarModal"
            @modalFechado="mostrarModal = false"
            :despesa="despesa"
            :servicos="servicos"
            @recarregarDespesas="$emit('recarregarDespesas')"
        ></dotacao-form>
    </span>
</template>

<script>
import DotacaoForm from './DotacaoForm';

export default {
    components: {
        DotacaoForm
    },

    props: {
        permiteAtualizarCentroCusto: {
            type: Boolean
        },

        servicos: {
            type: Object,
            default: () => ({})
        },

        despesa: {
            type: Object,
            default: () => ({})
        }, 
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    computed: {
        mostrarIcone() {
            return (
                this.permiteAtualizarCentroCusto 
            )
        }
    }
}    
</script>